/**
 * Tipos de aviso da central de avisos. O texto de cada tipo fica nos
 * arquivos de tradução (notifications.kinds.<tipo com _ no lugar do ponto>).
 */
export const NOTIFICATION_KINDS = [
  // Aviso de exemplo: quem recebeu um perfil de acesso. Cada módulo novo acrescenta os seus.
  'iam.role_granted',
] as const;
export type NotificationKind = (typeof NOTIFICATION_KINDS)[number];

/** Chave do texto do aviso nos arquivos de tradução. */
export function notificationTextKey(kind: string): string {
  return `notifications.kinds.${kind.replace('.', '_')}`;
}
